import { useSelector } from 'react-redux'

/********************************* 
 * 
 * instance
 * 
*/
export const selectInstance = state => state.instance
export const selectInstanceValue = state => state.instance && state.instance.value
export const useInstance = () => useSelector(selectInstance)
export const useInstanceValue = () => useSelector(selectInstanceValue)
